import * as React from 'react'
import { useState } from 'react'
import Select, { components } from 'react-select'
import { LocationData } from './types'
import Icons from '../../icons'
import { useTranslation } from 'react-i18next'
import {
  getLocationName,
  formatLocationOptionLabel,
  filterLocationOptions,
  locationSelectStyles
} from '@helpers/locationSelectHelpers'

const DropdownIndicator = (props: any) =>
  components.DropdownIndicator && (
    <components.DropdownIndicator {...props}>
      <Icons name="arrowDownThin" />
    </components.DropdownIndicator>
  )

interface LocationListProps {
  bulkUpdate?: boolean
  formattedLocations?: LocationData[]
  onListItemClick: (value: any) => void
}
export const LocationList = ({ formattedLocations, onListItemClick }: LocationListProps) => {
  const { t } = useTranslation()
  const [selected, setSelected] = useState<LocationData | undefined>()

  const options =
    formattedLocations && formattedLocations.length
      ? formattedLocations.map((item, index) => ({
          value: item.customer || (item as any)._id,
          label: getLocationName(item as any),
          location: item,
          index
        }))
      : []

  const handleChange = (value: any) => {
    if (value && value.location) {
      const loc = value.location as LocationData
      setSelected(loc)
      if (loc.customer) onListItemClick(loc.customer)
    } else {
      setSelected(undefined)
      onListItemClick('')
    }
  }

  return (
    <Select
      className="search-select h-100"
      classNamePrefix="globalSelect"
      placeholder={t('locations.select-a-location')}
      isSearchable={true}
      options={options}
      formatOptionLabel={formatLocationOptionLabel}
      filterOption={filterLocationOptions}
      styles={locationSelectStyles}
      isClearable={false}
      onChange={handleChange}
      value={
        selected && (selected.customer || (selected as any)._id)
          ? {
              value: selected.customer || (selected as any)._id,
              label: getLocationName(selected as any),
              location: selected
            }
          : null
      }
      noOptionsMessage={() => t('locations.no-locations')}
      components={{ DropdownIndicator }}
    />
  )
}
